import { PaynoteCheckStatus, SeamlessCheckStatus } from "./gateway.types.dto";

export type PaymentResponse<T> = {
  success: boolean;
  status: number;
  message: string;
  data?: T;
  error?: unknown;
};

export enum Currency {
  USD = "usd",
  EUR = "eur",
  INR = "inr",
}

export enum InvoiceStatus {
  DRAFT = "draft",
  OPEN = "open",
  PAID = "paid",
  PARTIAL = "partial",
  VOID = "void",
  OVERDUE = "overdue",
}

export enum LockStatus {
  LOCKED = "locked",
  UNLOCKED = "unlocked",
}

export enum Gateway {
  STRIPE = "stripe",
  SEAMLESSCHEX = "seamlesschex",
  SEAMLESSCHEX_MERCHANT = "seamlesschex_merchant",
  PAYNOTE = "paynote",
  MANUALLY_MARKED = "manually_marked",
  AUTOMATED_DISTRIBUTION = "automated_distribution",
}

export enum TransactionStatus {
  PENDING = "pending",
  PROCESSING = "processing",
  SUCCEEDED = "succeeded",
  FAILED = "failed",
  CANCELLED = "cancelled",
}

export enum TransactionType {
  REFUND = "refund",
  CHECK = "check",
  CREDIT_CARD = "credit_card",
  CREDIT = "credit",
  DEBIT = "debit",
}

export type GatewayMetaMap = {
  [Gateway.STRIPE]: {
    payment_id: string;
  };

  [Gateway.SEAMLESSCHEX]: {
    check_id: string;
    store?: string;
    last_status: SeamlessCheckStatus;
    verification_description?: string;
    funds_confirmation_description?: string;
  };

  [Gateway.PAYNOTE]: {
    customer_id: string;
    source_id: string;
    check_id: string;
    last_status: PaynoteCheckStatus;
  };

  [Gateway.SEAMLESSCHEX_MERCHANT]: {
    transaction_id: string;
    auth_code: string;
    last4?: string;
    response_text: string;
    token?: string;
    customer_vault_id?: string;
  };

  [Gateway.MANUALLY_MARKED]: {
    ref_transaction_id?: string;
  };

  [Gateway.AUTOMATED_DISTRIBUTION]: {
    ref_transaction_id?: string;
  };
};

export type TransactionDto<G extends Gateway = Gateway> = {
  gateway: G;
  type: TransactionType;
  status: TransactionStatus;
  amount: number;
  starting_balance?: number;
  ending_balance?: number;
  lock_status?: LockStatus;
  currency: Currency;
  meta: GatewayMetaMap[G] & { appkey?: string; ledger_id?: string; posting_date?: string };
  processed_at?: Date;
  failure_reason?: string;
  wallet_id?: string;
  posting_date: string;
  description: string;
  hasReconciliated: boolean;
  _id: string;
};
